
import { ConditionPrelevementLac } from "./condition-prelevement-lac";
import { ELacProcessTypes } from "./enum/lac-process-types";
import { PhysiqueChimieInSitu } from "./physique-chimie-insitu";
import { PrelPhyto } from "./prel-phyto";
import { PrelevementLac } from "./prelevement-lac";

export class LacProcess {
    Code: string
    /** Bit mask based on ELacProcessTypes */
    Types: number;

    ConditionPrelevement: ConditionPrelevementLac = new ConditionPrelevementLac();

    PhysiqueChimieInSitu: PhysiqueChimieInSitu = new PhysiqueChimieInSitu();
    PrelEauIntegre: PrelevementLac = new PrelevementLac();
    PrelSediment: PrelevementLac = new PrelevementLac();
    PrelEauPonctuelList: PrelevementLac[] = [];
    PrelPhyto: PrelPhyto = new PrelPhyto();

    Is(type: ELacProcessTypes) {
        return !!(this.Types & type);
    }

    static mapFromJSON(json: any): LacProcess {
        const p = new LacProcess();

        p.Code = json.code;
        p.Types = json.types; 
        if (json.conditionPrelevement) {
            p.ConditionPrelevement = ConditionPrelevementLac.mapFromJSON(json.conditionPrelevement);
        }
        if (json.physiqueChimieInSitu) {
            p.PhysiqueChimieInSitu = PhysiqueChimieInSitu.mapFromJSON(json.physiqueChimieInSitu);
        }
        if (json.prelEauIntegre) {
            p.PrelEauIntegre = PrelevementLac.mapFromJSON(json.prelEauIntegre);
        }
        if (json.prelSediment) {
            p.PrelSediment = PrelevementLac.mapFromJSON(json.prelSediment);
        }
        if (json.prelPhyto) {
            p.PrelPhyto = PrelPhyto.mapFromJSON(json.prelPhyto);
        }
        if (json.prelEauPonctuelList) {
            p.PrelEauPonctuelList = json.prelEauPonctuelList.map(jsonItem => PrelevementLac.mapFromJSON(jsonItem));
        }
        return p;
    }
}
